import { bool, number } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";

import { useGetFormattedPrice } from "@hooks/useGetFormattedPrice";
import { financeGatewayTeaserType } from "@types";
import { useIsLOAPriceBreakdownRequestErrorSelector } from "@redux/reducers/requests";
import { useIsB2BSelected } from "@hooks/useIsB2BSelected";
import { useFinanceGatewayDataParser } from "@hooks/useFinanceGatewayDataParser";

const LOAPriceDetail = ({ withFinanceWidgetButton, amount, teaser }) => {
  const { t } = useTranslation();

  const isLOAPriceBreakdownRequestError = useIsLOAPriceBreakdownRequestErrorSelector();
  const isB2BSelected = useIsB2BSelected();
  const financeGatewayDataParser = useFinanceGatewayDataParser();

  const getFormattedPrice = useGetFormattedPrice();

  if (!teaser || !amount) {
    return (
      <Typography className="text-white text-lg text-center font-semibold m-auto max-w-80 px-4 text-balance">
        {t("financeDataErrorMessage")}
      </Typography>
    );
  }

  return (
    <div
      className={twMerge(
        "flex flex-col justify-center items-end h-full pr-4 z-10 text-white min-w-48",
        withFinanceWidgetButton &&
          "relative mr-2 sm:mr-4 after:content-[''] after:absolute after:top-1/5 after:bottom-1/5 after:-right-1 after:w-px after:bg-greyLight sm:after:-right-3",
        "sm:p-4 md:p-2 lg:px-0 lg:py-1"
      )}
      data-id="price-switcher-price-container"
    >
      {isLOAPriceBreakdownRequestError ? (
        <Typography className="text-white text-lg text-center font-semibold m-auto max-w-80 px-4 text-balance">
          {t("financeDataErrorMessage")}
        </Typography>
      ) : (
        <>
          <div>
            <Typography className="text-white">
              <span
                className="text-lg/1 font-semibold"
                data-id="price-switcher-formatted-price"
              >
                {getFormattedPrice(amount)}
              </span>
              <sup className="text-xxs/1">
                {" "}
                {isB2BSelected
                  ? t("price.b2b.month")
                  : t("price.b2c.month")}{" "}
              </sup>
              <sup className="text-lg/1 font-semibold -top-1.5">*</sup>
            </Typography>
          </div>

          {financeGatewayDataParser("primarytext", teaser).map(
            ({ parsedText, targetItem }, index) => (
              <Typography
                className={twMerge(
                  "inline text-white text-right",
                  targetItem.style?.displaySize
                    ? "text-xs/1"
                    : "text-[0.55rem]/[1.1]",
                  targetItem.style?.displaySize
                    ? "font-semibold"
                    : "font-normal"
                )}
                key={index}
              >
                {parsedText}
              </Typography>
            )
          )}
        </>
      )}
    </div>
  );
};

LOAPriceDetail.propTypes = {
  withFinanceWidgetButton: bool,
  amount: number,
  teaser: financeGatewayTeaserType,
};

export default LOAPriceDetail;
